<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill-opacity="0.54"
    :class="{ 'light-color': hasActiveFilters }"
  >
    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
  </svg>
</template>

<script>
export default {
  name: 'FilterIcon',
  props: {
    hasActiveFilters: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/styles/colors';

.light-color {
  fill: $gd-white;
  fill-opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/FilterIcon.vue